<span class="font-medium-title-large">
  {{ type === 'file' ? 'Datei bearbeiten' : 'Link bearbeiten' }}
</span>

<form [formGroup]="form" class="flex-c gap-24 w-full" (ngSubmit)="submit()">
  <div class="input-simple">
    <div class="input-label">
      {{ type === 'file' ? 'Dateiname' : 'Link-Titel'
      }}{{ fieldRequired(form.get('name')) ? '*' : '' }}
    </div>
    <input class="input-field" formControlName="name" type="text" />
    <app-error-message [formField]="form.get('name')"></app-error-message>
  </div>
  @if (type === 'link') {
    <div class="input-simple">
      <div class="input-label">
        Link-URL{{ fieldRequired(form.get('url')) ? '*' : '' }}
      </div>
      <input class="input-field" formControlName="url" type="text" />
      <app-error-message [formField]="form.get('url')"></app-error-message>
    </div>
  }

  <div class="input-simple">
    <div class="input-label">Tags*</div>
    <app-tag-selector
      [selectedTags]="selectedTags"
      (selectedTagsChange)="selectedTagsChange($event)"></app-tag-selector>
  </div>

  @if (seminarOptions.length > 0) {
    <div class="input-select">
      <div class="input-label">Seminare*</div>
      <p-multiSelect
        [options]="seminarOptions"
        formControlName="seminarIds"
        appendTo="body"
        optionLabel="title"
        optionValue="id"
        placeholder="Seminare auswählen">
        <ng-template let-seminar pTemplate="item">
          <div class="flex align-items-center">
            <div>{{ seminar.title }}</div>
            @if (seminar.dates && seminar.dates.length > 0) {
              <span class="font-regular-body-medium text-secondary">
                {{ getSeminarDateString(seminar) }}
              </span>
            }
            @if (seminar.isDraft) {
              <span class="is-draft-tag"> Entwurf</span>
            }
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  }

  <div class="flex-r gap-16 justify-center">
    <button
      type="button"
      class="inwi-text-button-large-secondary flex-1-0-0"
      (click)="closeDialog()">
      <div class="button-content"><div class="button-text">Abbrechen</div></div>
    </button>
    <button type="submit" class="inwi-text-button-large-primary flex-1-0-0">
      <div class="button-content"><div class="button-text">Speichern</div></div>
    </button>
  </div>
</form>
